import { createSelector } from 'reselect';
import { getAlertHistory } from '../rootSelectors';

const isLoadingAlertsWithFilter = createSelector([getAlertHistory], alarm => alarm.isLoadingAlertsWithFilter);

export { isLoadingAlertsWithFilter };
